import { HttpErrorResponse } from '@angular/common/http';
import { Constants } from '../constants';
import { MtaServerError } from '#models/mtaServerError';
import { ErrorDialogModel } from '#models/errorDialogModel';

export class MtaServerErrorHandler {
  public static convertToErrorDialogModel(response: HttpErrorResponse) : ErrorDialogModel {
    const mtaError = new MtaServerError(response.error);
    const resolvedDetail = mtaError.message || mtaError.detail
      || (typeof response.error === 'string' ? response.error : '')
      || response.statusText
      || '';

    const msg = new ErrorDialogModel();
    msg.id = 'error-dialog';
    msg.errorStatus = response.status;
    switch (response.status) {
      case 403:
        msg.severity = 'warn';
        msg.summary = Constants.AuthorizationErrorMsgTitle;
        msg.detail = `${resolvedDetail}
        <br/><b>Please follow below Steps :</b> 
        <br/><b>1.</b> To proceed, please reach out to the Primavera system administrator to obtain Primavera access. 
        <br/><b>2.</b> Please contact your Scheduler admin to obtain application access.`;
        break;
      case 422:
        msg.severity = 'warn';
        msg.summary = Constants.BusinessErrorMsgTitle;
        msg.detail = MtaServerErrorHandler.formatBusinessExceptionDetail(resolvedDetail);
        break;
       case 502:
        msg.severity = 'error';
        msg.summary = Constants.PrimaveraErrorMsgTitle;
        msg.detail = MtaServerErrorHandler.formatBusinessExceptionDetail(resolvedDetail);
        break;
      case 500:
        msg.severity = 'error';
        msg.summary = Constants.ServerErrorMsgTitle;
        msg.detail = MtaServerErrorHandler.formatBusinessExceptionDetail(resolvedDetail);
        break;
      case 400:
        msg.severity = 'error';
        msg.summary = Constants.BusinessErrorMsgTitle;
        msg.detail = MtaServerErrorHandler.formatBusinessExceptionDetail(resolvedDetail);
        break;
      case 404:
        msg.severity = 'error';
        msg.summary = Constants.NotFoundErrorMsgTitle;
        msg.detail = MtaServerErrorHandler.formatBusinessExceptionDetail(resolvedDetail);
        break;
      default:
        msg.severity = 'error';
        msg.summary = Constants.UnknownErrorMsgTitle;
        msg.detail = MtaServerErrorHandler.formatBusinessExceptionDetail(resolvedDetail);
        break;
    }
    return msg;
  }

  private static formatBusinessExceptionDetail(detail: string): string {
    // Remove exception class name prefix (e.g., "GUIT.FWE.TurnAround.Core.Exceptions.BusinessException: ")
    let message = detail.replace(/^[A-Za-z.]+Exception:\s*/, '');
    
    // Remove stack trace (everything from " at " onwards)
    message = message.split(/\s+at\s+/)[0].trim();
    
    // Remove extra instruction text like "Please Correct the Dates in Primavera"
   // message = message.replace(/\s*Please Correct the Dates in Primavera\.?\s*/i, '');
    
    // Extract activity IDs (pattern: R-XXXX.XXXX.XXXX)
const activityIdMatch = message.match(/Activities:\s*((?:[A-Za-z0-9]+(?:[.-][A-Za-z0-9]+)+\s*)+[A-Za-z0-9]+(?:[.-][A-Za-z0-9]+)+)/);    
    if (activityIdMatch && activityIdMatch.index !== undefined) {
      const beforeActivities = message.substring(0, activityIdMatch.index).trim();
      const activityIds = activityIdMatch[1].trim().split(/[\s,]+/).filter(Boolean).join(', ');
      const afterActivities = message.substring(activityIdMatch.index + activityIdMatch[0].length).trim();
      
      // Format with activity IDs on a new line
      return `${beforeActivities} Activities:<br/><b>(${activityIds})</b><br/>${afterActivities}`;
    }

    return message;
  }
}

